import React from "react";
import { connect } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import LoadingComponent from "../components/LoadingComponent";
import { writeSplitwiseToken } from "../redux/actions";

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const TokenAccept = ({ splitwiseToken, writeSplitwiseToken, auth }) => {
  const query = useQuery();
  const token = query.get("token");
  if (auth) writeSplitwiseToken(token);
  if (!token) return "splitwise error: There is no token in the query string";
  if (splitwiseToken) return <Redirect to="/a" />;
  return <LoadingComponent />;
};

const mapStateToProps = (state) => ({
  splitwiseToken: state.firebase.profile.splitwiseToken,
  auth: state.firebase.auth,
});

export default connect(mapStateToProps, { writeSplitwiseToken })(TokenAccept);
